import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EditTask, Task, TaskSwimLane } from '@app/interfaces/lm/kanban-board';
import { KanbanBoardService } from '@services/lm/kanban-board.service';
import { ConfirmationService } from '@services/sys/confirmation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-sub-task-item',
    templateUrl: './sub-task-item.component.html',
    styleUrl: './sub-task-item.component.less'
})
export class SubTaskItemComponent {
    @Input() item!: Task;
    @Input() swimLaneList: TaskSwimLane[] = [];
    @Input() inactiveUsers: boolean = false;

    @Output() remove = new EventEmitter();
    statusLoading = false;
    projectKey = '';

    constructor(private kanbanBoardService: KanbanBoardService,
        private router: Router,
        private modal: NzModalService,
        private message: NzMessageService,
        private confirmationService: ConfirmationService,) {
    }

    async ngOnInit(): Promise<void> {
        this.projectKey = this.getProjectKey(this.item.taskKey);
    }

    async changeTaskStatus(taskInfo: Task, swimLane: TaskSwimLane): Promise<void> {
        try {
            if (taskInfo.swimLaneId === swimLane.id) {
                return;
            }
            this.statusLoading = true;
            // sub task
            const params = {
                taskId: taskInfo.subTaskId as string,
                swimLaneId: swimLane.id,
            };
            const swimLaneInfo = this.swimLaneList.find(item => item.id === taskInfo.swimLaneId);
            if (swimLaneInfo?.category === 'OTHER' && swimLane.category !== 'OTHER') {
                const modalRef = this.modal.create({
                    nzTitle: 'Proceed with task completion?',
                    nzContent: `<ul style="padding-left: 20px; margin: 0;">
                                <li><b>OK</b>: Auto-release assignments and set today as Due Date.</li>
                                <li><b>No</b>: Leave unchanged for manual review.</li>
                                </ul>`,
                    nzStyle: { top: '40vh' },
                    nzFooter: [
                        {
                          label: 'No',
                          onClick: async () => {
                              this.confirmationService.confirmUpdateTask(this.inactiveUsers, async () => {
                                  await this.kanbanBoardService.updateSubTaskSwimLane(params);
                                  taskInfo.swimLaneId = swimLane.id;
                                  taskInfo.swimLaneName = swimLane.swimLaneName;
                                  this.message.success('Status updated successfully');
                                  this.statusLoading = false;
                              })
                              modalRef.close();
                          }
                        },
                        {
                            label: 'OK',
                            type: 'primary',
                            danger: true,
                            onClick: async () => {
                                this.confirmationService.confirmUpdateTask(this.inactiveUsers, async () => {
                                    await this.kanbanBoardService.releaseAllResource(taskInfo, swimLane.id, this.projectKey);
                                    taskInfo.swimLaneId = swimLane.id;
                                    taskInfo.swimLaneName = swimLane.swimLaneName;
                                    this.message.success('Status updated successfully');
                                    this.statusLoading = false;
                                });
                                modalRef.close();
                            }
                        }
                    ],
                    nzOnCancel: async () => {
                        this.statusLoading = false;
                        modalRef.close();
                    }
                });
            } else {
                this.confirmationService.confirmUpdateTask(this.inactiveUsers, async () => {
                    await this.kanbanBoardService.updateSubTaskSwimLane(params);
                    taskInfo.swimLaneId = swimLane.id;
                    taskInfo.swimLaneName = swimLane.swimLaneName;
                    this.message.success('Status updated successfully');
                });
            }
        } finally {
            this.statusLoading = false;
        }
    }

    switchFullscreen(): void {
        this.router.navigateByUrl(`/kanban-board/${this.projectKey}/task/${this.item.taskKey}`);
    }

    getProjectKey(taskKey: string): string {
        const separatorIndex = taskKey.indexOf('-');
        return separatorIndex !== -1 ? taskKey.substring(0, separatorIndex) : taskKey;
    }

    handleRemove(): void {
        this.remove.emit();
    }
}

